import type { VariantProps } from 'class-variance-authority'
import { largeTextVariants, monoTitleVariants } from '@/components/ui/typography.variants'
import { cn } from '@/lib/cn'

/*
 * Typography atoms that recur across sections.
 *
 * Webflow expresses these as stacked utility classes (`.large-text.white.center`,
 * `.mono-component-title.white.opacity75`). Each becomes a variant so the
 * combinations stay finite instead of multiplying across every page.
 */

export interface LargeTextProps
  extends React.HTMLAttributes<HTMLParagraphElement>,
    VariantProps<typeof largeTextVariants> {
  as?: 'p' | 'div'
}

/** `.large-text` — 1.4rem/1.4em, the standard hero and CTA subheading. */
export function LargeText({
  className,
  tone,
  align,
  width,
  as: Tag = 'p',
  ...props
}: LargeTextProps) {
  return <Tag className={cn(largeTextVariants({ tone, align, width }), className)} {...props} />
}

export interface MonoTitleProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof monoTitleVariants> {}

/** `.mono-component-title` — the small uppercase eyebrow above a section. */
export function MonoTitle({ className, tone, ...props }: MonoTitleProps) {
  return <div className={cn(monoTitleVariants({ tone }), className)} {...props} />
}
